import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, } from "react";
import { createSecureTrustedPresenceControllerV1 } from "./security/trusted-presence.js";
const Ctx = createContext(null);
export function CollabProvider({ wsUrl, getAccessToken, protocolMode, secure, children, }) {
    const value = useMemo(() => ({
        wsUrl,
        getAccessToken,
        ...(protocolMode === undefined ? {} : { protocolMode }),
        ...(secure === undefined
            ? {}
            : {
                secure: {
                    ...secure,
                    createAdapter: secure.createAdapter ??
                        ((input) => createSecureTrustedPresenceControllerV1({
                            document: input.document,
                            mode: input.mode,
                        })),
                },
            }),
    }), [wsUrl, getAccessToken, protocolMode, secure]);
    return _jsx(Ctx.Provider, { value: value, children: children });
}
export function useCollabProviderConfig() {
    const value = useContext(Ctx);
    if (!value) {
        throw new Error("@playbookai/collab-client: missing <CollabProvider> in the React tree. " +
            "Mount it inside your authenticated app shell.");
    }
    return value;
}
//# sourceMappingURL=CollabProvider.js.map